import { Component, effect, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { UserService } from '@services/user.service';
import { CheckboxComponent } from '@shared/elements/checkbox/checkbox.component';
import { CommonButtonComponent } from '@shared/elements/common-button/button.component';
import { ImageComponent } from '@shared/elements/image/image.component';
import { TextFieldComponent } from '@shared/elements/text-field/text-field.component';
import { LocalStorageService } from '../../../services/local-storage.service';

@Component({
  selector: 'app-account-verify',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterLink,
    CommonButtonComponent,
    CheckboxComponent,
    TextFieldComponent,
    ImageComponent,
  ],
  templateUrl: './account-verify.component.html',
})
export class AccountVerifyComponent implements OnInit {
  loggedIn: boolean = false;

  private token: string = '';

  passwordType: 'text' | 'password' = 'password';

  mismatch: boolean = false;

  logoId?: string | number;

  showPasswords: boolean = false;

  user = new FormGroup({
    token: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.minLength(4), Validators.maxLength(60), Validators.required]),
    confirmPassword: new FormControl('', [Validators.minLength(4), Validators.maxLength(60), Validators.required]),
  });

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private userService: UserService,
    private storage: LocalStorageService,
  ) {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];
      this.getControl('token').setValue(this.token);
    });

    effect(() => {
      this.loggedIn = this.storage.isLoggedIn();

      this.logoId = this.storage.logoId();
    });
  }

  ngOnInit() {
    if (this.loggedIn) {
      this.router.navigate(['/admin/dashboard']);
    }
  }

  submit() {
    if (this.user.valid && !this.mismatch) {
      const data = {
        token: this.token,
        password: this.getValue('password'),
      };

      this.userService.setForgottenPassord(data).subscribe((res) => {
        if (res) {
          this.router.navigate(['/login']);
        }
      });
    }
  }

  getControl(controlName: string): FormControl {
    return this.user.get(controlName) as FormControl;
  }

  toggleType(): void {
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
  }

  getValue(controlName: string) {
    return this.getControl(controlName).value;
  }

  getErrorMessage(controlName: string, showError: boolean = false): string {
    const control = this.getControl(controlName);
    if (control.touched || showError) {
      if (control.hasError('required')) {
        return `This field is required.`;
      } else if (control.hasError('pattern')) {
        return `Invalid ${controlName} value.`;
      } else if (control.hasError('maxlength')) {
        return `${controlName} exceeds max length.`;
      }

      if (controlName === 'confirmPassword' && control.value !== this.getValue('password')) {
        this.mismatch = true;
        return 'Passwords must match';
      } else {
        this.mismatch = false;
      }
    }

    return '';
  }
}
